import { requestInvoices } from "hiringagent-dashboard/actions/invoices";
import { invoicesSliceSelector } from "hiringagent-dashboard/selectors";
import { createConnector } from "common/connectors/utils";

export default createConnector("WithInvoices", invoicesSliceSelector, {
  onLoad: requestInvoices,
});
